import type { WiwState } from '@/store';

export const stripePlanItems = (state: WiwState) => state.data.stripe.plans.items;
export const getStripePlans = stripePlanItems;
